import * as Yup from "yup";
import { StandaardRapportOptions } from "../../../.generated/instellingen-forms/instellingen-formstypes";
import { yupEnum, yupNullableEnum } from "../../utils/yup-enum";
import { RapportageElementSoort } from "./infra/rapportage-structuur-types";
import { RapportageElementType, KolomDefinitieType } from "./infra/rapportage-samenstellen-types";

export const kolommenLastenSchema = Yup.object({
  brutoInkomen: Yup.boolean().default(false),
  somHypotheken: Yup.boolean().default(true),
  waardeopbouw: Yup.boolean().default(false),
  huur: Yup.boolean().default(false),
  rente: Yup.boolean().default(true),
  hypotheekAflossing: Yup.boolean().default(true),
  uitkeringKapitaalverzekering: Yup.boolean().default(true),
  verzekeringspremies: Yup.boolean().default(true),
  spaarBeleggingsdepots: Yup.boolean().default(true),
  opnameUitDepot: Yup.boolean().default(true),
  kredietLast: Yup.boolean().default(true),
  overigeUitgaven: Yup.boolean().default(true),
  brutoLast: Yup.boolean().default(true),
  fiscaalVoordeel: Yup.boolean().default(true),
  vrh: Yup.boolean().default(true),
  nettoLast: Yup.boolean().default(true)
});

export const kolommenNbiSchema = Yup.object({
  hypotheek: Yup.boolean().default(true),
  verzekeringen: Yup.boolean().default(true),
  spaarBeleggingsdepots: Yup.boolean().default(true),
  kredietLast: Yup.boolean().default(true),
  overigeUitgaven: Yup.boolean().default(true),
  brutoLast: Yup.boolean().default(true),
  inkomstenbelasting: Yup.boolean().default(true),
  vrh: Yup.boolean().default(true),
  nettoInkomen: Yup.boolean().default(true),
  nbi: Yup.boolean().default(true)
});

export const kolommenInstellenModalSchema = Yup.object({
  kolommenLasten: kolommenLastenSchema,
  kolommenNbi: kolommenNbiSchema
}).nullable();

export const kolomDefinitieSchema = Yup.object({
  kolomTitel: Yup.string(),
  kolomNaam: Yup.string(),
  selected: Yup.boolean()
});

export const rapportageElementSchema = Yup.object({
  code: Yup.number(),
  naam: Yup.string(),
  naamWeergevenAlsTitel: Yup.boolean().default(true),
  inhoudBeschikbaar: Yup.boolean().default(true),
  geselecteerd: Yup.boolean(),
  soortElement: yupEnum(RapportageElementSoort),
  volgnummer: Yup.number(),
  elementen: Yup.array<any>().default([]),
  kolommen: Yup.array<KolomDefinitieType>().default([]),
  inhoud: Yup.string()
    .nullable()
    .default(null),
  perAdviesAanpasbaar: Yup.boolean()
    .nullable()
    .default(null),
  gebruikAi: Yup.boolean()
    .nullable()
    .default(null),
  promptNaam: Yup.string()
    .nullable()
    .default(null),
  promptAanvulling: Yup.string()
    .nullable()
    .default(null)
});

export const rapportageStructuurSchema = Yup.object({
  structuurId: Yup.string().nullable(),
  naam: Yup.string(),
  volgnummer: Yup.number(),
  standaardRapport: yupNullableEnum(StandaardRapportOptions), //hypotheekadvies = v2
  kolomselectie: kolommenInstellenModalSchema, // in v1 altijd gevuld
  elementen: Yup.array<RapportageElementType>(rapportageElementSchema).default([]),
  isVerwijderbaar: Yup.boolean().default(true)
});

export const rapportageSamenstellenSchema = Yup.object({
  structuren: Yup.array(rapportageStructuurSchema).default([]),
  defaultStructuur: rapportageStructuurSchema,
  movetoparent: Yup.string()
    .nullable()
    .default(null)
});
